(function () {
  var SECTION_SELECTOR = '.oddit-section-product-reviews-carousel';

  function initSection(section) {
    var track = section.querySelector('.oddit-section-product-reviews-carousel__track');
    var prevBtn = section.querySelector('.oddit-section-product-reviews-carousel__nav--prev');
    var nextBtn = section.querySelector('.oddit-section-product-reviews-carousel__nav--next');
    var dotsContainer = section.querySelector('.oddit-section-product-reviews-carousel__dots');
    var realCards = Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-product-reviews-carousel__card')
    );

    if (!track || realCards.length === 0) return;
    if (track.getAttribute('data-loop-initialized') === 'true') return;
    track.setAttribute('data-loop-initialized', 'true');

    var N = realCards.length;

    // ---- Build clones for a seamless infinite loop ----
    // Track layout becomes: [clones(N)] [reals(N)] [clones(N)].
    function stripReveal(root) {
      var nodes = [root].concat(Array.prototype.slice.call(root.querySelectorAll('*')));
      nodes.forEach(function (node) {
        if (!node.classList) return;
        Array.prototype.slice.call(node.classList).forEach(function (cls) {
          if (cls.indexOf('oddit-reveal') === 0) node.classList.remove(cls);
        });
      });
    }

    function makeClone(card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.classList.add('oddit-section-product-reviews-carousel__card--clone');
      // clones are always-visible duplicates; never let them animate in
      stripReveal(clone);
      // keep clones out of the tab order
      Array.prototype.slice.call(clone.querySelectorAll('a, button')).forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
      return clone;
    }

    var firstReal = realCards[0];
    realCards.forEach(function (card) {
      track.insertBefore(makeClone(card), firstReal); // leading clones
    });
    realCards.forEach(function (card) {
      track.appendChild(makeClone(card)); // trailing clones
    });

    var slides = Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-product-reviews-carousel__card')
    );

    var dots = [];
    var currentDom = N; // first real slide
    var isAdjusting = false;
    var dragActive = false;
    var scrollRaf = null;
    var settleTimer = null;

    function posOf(domIndex) {
      return slides[domIndex].offsetLeft - slides[0].offsetLeft;
    }

    function nearestDom() {
      var sl = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var dist = Math.abs(posOf(i) - sl);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function logicalIndex(domIndex) {
      return ((domIndex - N) % N + N) % N;
    }

    function setScrollInstant(pos) {
      isAdjusting = true;
      var snap = track.style.scrollSnapType;
      var behavior = track.style.scrollBehavior;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = pos;
      requestAnimationFrame(function () {
        track.style.scrollSnapType = snap;
        track.style.scrollBehavior = behavior;
        requestAnimationFrame(function () {
          isAdjusting = false;
        });
      });
    }

    function buildDots() {
      if (!dotsContainer) return;
      while (dotsContainer.firstChild) {
        dotsContainer.removeChild(dotsContainer.firstChild);
      }
      dots = [];
      for (var i = 0; i < N; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'oddit-section-product-reviews-carousel__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        var span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        span.innerHTML = '&zwnj;';
        dot.appendChild(span);
        (function (idx) {
          dot.addEventListener('click', function () {
            scrollToDom(N + idx);
          });
        })(i);
        dotsContainer.appendChild(dot);
        dots.push(dot);
      }
    }

    function updateActiveDot() {
      var active = logicalIndex(currentDom);
      dots.forEach(function (dot, idx) {
        if (idx === active) {
          dot.classList.add('oddit-section-product-reviews-carousel__dot--active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('oddit-section-product-reviews-carousel__dot--active');
          dot.removeAttribute('aria-current');
        }
      });
    }

    function scrollToDom(domIndex) {
      currentDom = domIndex;
      track.scrollTo({ left: posOf(domIndex), behavior: 'smooth' });
      updateActiveDot();
    }

    // After scrolling settles, if we are parked on a clone, jump instantly to
    // the matching real slide. Content is identical, so the jump is invisible.
    function normalize() {
      if (isAdjusting || dragActive) return;
      var nearest = nearestDom();
      currentDom = nearest;
      var normalized = nearest;
      if (nearest < N) normalized = nearest + N;
      else if (nearest >= 2 * N) normalized = nearest - N;
      if (normalized !== nearest) {
        currentDom = normalized;
        setScrollInstant(posOf(normalized));
      }
      updateActiveDot();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToDom(currentDom - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToDom(currentDom + 1);
      });
    }

    // Live dot feedback while the user swipes
    track.addEventListener('scroll', function () {
      if (isAdjusting) return;
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(function () {
        currentDom = nearestDom();
        updateActiveDot();
      });
    }, { passive: true });

    // Settle detection → normalize the loop
    if ('onscrollend' in window) {
      track.addEventListener('scrollend', normalize);
    } else {
      track.addEventListener('scroll', function () {
        if (settleTimer) clearTimeout(settleTimer);
        settleTimer = setTimeout(normalize, 140);
      }, { passive: true });
    }

    // On resize, keep the current slide aligned (widths change per breakpoint)
    var resizeRaf = null;
    window.addEventListener('resize', function () {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () {
        setScrollInstant(posOf(currentDom));
      });
    });

    // ---- Desktop drag-to-scroll (mouse only; touch keeps native scrolling) ----
    var dragStartX = 0;
    var dragLastX = 0;
    var dragMoved = false;

    var DRAG_THRESHOLD = 10;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (typeof e.button === 'number' && e.button !== 0) return;
      if (track.scrollWidth <= track.clientWidth) return;
      dragActive = true;
      dragMoved = false;
      dragStartX = e.clientX;
      dragLastX = e.clientX;
      track.classList.add('is-dragging');
    });

    window.addEventListener('pointermove', function (e) {
      if (!dragActive) return;
      var dx = e.clientX - dragLastX;
      dragLastX = e.clientX;
      if (Math.abs(e.clientX - dragStartX) > DRAG_THRESHOLD) dragMoved = true;
      track.scrollLeft -= dx;
    });

    function endDrag() {
      if (!dragActive) return;
      dragActive = false;
      track.classList.remove('is-dragging');
      if (dragMoved) {
        scrollToDom(nearestDom()); // settle on the nearest card
        window.setTimeout(function () {
          dragMoved = false;
        }, 0);
      }
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    // A drag ends in a click; swallow it so the link doesn't navigate.
    track.addEventListener('click', function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }, true);

    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    buildDots();
    updateActiveDot();
    setScrollInstant(posOf(currentDom));
    // re-align once more after fonts/images may have shifted widths
    requestAnimationFrame(function () {
      setScrollInstant(posOf(currentDom));
    });
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
